import ElPopconfirm from './Popconfirm'

/* istanbul ignore next */
ElPopconfirm.install = function (app) {
  app.component(ElPopconfirm.name, ElPopconfirm)
}

export default ElPopconfirm
